import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FirestoreService } from 'src/app/services/firestore.service';


@Component({
  selector: 'app-painting-list',
  templateUrl: './painting-list.component.html',
  styleUrls: ['./painting-list.component.sass']
})
export class PaintingListComponent implements OnInit {

  logoImage: string = "./assets/img/no-logo.png";
  coverImage: string = "./assets/img/cover-ads.png";

  paintingCol;
  
  constructor(    
    private route: Router,
    private aroute: ActivatedRoute,
    public db: FirestoreService
  ) { }

  ngOnInit(): void {
    this.paintingCol = this.db.getMainColWhere('storeproducts', 'category', 'Painting');
  };

  routePaintingDetailPage(docId){
    this.route.navigateByUrl('painting/'+docId);
  }

}